var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 6,
    viewBox: "0 0 7 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.8975 0.102519C6.76082 -0.0341729 6.53922 -0.0341729 6.40252 0.102519L2.2093 4.29578L0.597495 2.68397C0.460817 2.54728 0.239224 2.5473 0.102519 2.68397C-0.0341729 2.82065 -0.0341729 3.04225 0.102519 3.17894L1.96181 5.0382C2.09845 5.17488 2.32021 5.17478 2.45679 5.0382L6.8975 0.597495C7.03419 0.460817 7.03417 0.23921 6.8975 0.102519Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.a5a816767a29884144feac28597dd1fc.svg";
export { ForwardRef as ReactComponent };